import React from 'react';
import {Pressable, StyleSheet, View} from 'react-native';
import CCText from '@/Atoms/CCText';
import {lbColors, lbRadius, lbShadow} from '../leaderboardTheme';
import {PERIODS, Period} from '../types';

interface Props {
  period: Period;
  onChange: (period: Period) => void;
}

/** Daily / Weekly pill tabs, gold active state. */
export default function PeriodTabs({period, onChange}: Props) {
  return (
    <View style={[styles.tabs, lbShadow.card]}>
      {PERIODS.map(p => {
        const active = p.key === period;
        return (
          <Pressable
            key={p.key}
            onPress={() => onChange(p.key)}
            style={[styles.tab, active && styles.tabActive]}>
            <CCText
              fontSize={14.5}
              fontWeight="bold"
              color={active ? lbColors.goldInk : lbColors.muted}>
              {p.label}
            </CCText>
          </Pressable>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  tabs: {
    flexDirection: 'row',
    gap: 6,
    backgroundColor: lbColors.card,
    padding: 6,
    borderRadius: lbRadius.md,
    alignSelf: 'flex-start',
  },
  tab: {
    paddingVertical: 10,
    paddingHorizontal: 24,
    borderRadius: lbRadius.sm + 2,
  },
  tabActive: {
    backgroundColor: lbColors.gold,
  },
});
